import React, { Component } from 'react';
import { extendObservable, action } from 'mobx';
import { observer } from 'mobx-react';
import { ClimbingBoxLoader } from 'react-spinners';

const LoadingComponent = observer(
class LoadingComponent extends Component {
  render() {
    const show = LoadingUI.bShow;
    let style = {
      backgroundColor: "#00bc99",
      display: show ? "flex" : "none",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      color: "white",
      position: "absolute",
      height: "100vh",
      width: "100vw",
      top: "0px",
      left: "0px",
      zIndex: show ? 99999999 : -1,
    }

    return (
      <div style={style}>
        <ClimbingBoxLoader color="#ffffff" />
        <div style={{fontSize: "15pt"}}>Passcode.io</div>
      </div>
    );
  }
});

class LoadingController {
  constructor() {
    extendObservable(this, {
      bShow: false,
    });
  }

  show = action(() => {
    this.bShow = true;
  });

  hide = action(() => {
    this.bShow = false;
  })
}

const LoadingUI = new LoadingController();

export default LoadingUI;
export {
  LoadingUI,
  LoadingComponent,
};


// WEBPACK FOOTER //
// ./src/tools/Loading.js